import React from "react";
import { Svg, Path } from "react-native-svg";
import { theme } from "@lookiero/sty-psp-ui";

const Camera = () => {
  const { colorIcon } = theme();

  return (
    <Svg fill="none" viewBox="0 0 40 40">
      <Path
        d="M38 32.4445C38 33.3874 37.6552 34.2918 37.0414 34.9586C36.4277 35.6254 35.5953 36 34.7273 36H5.27273C4.40475 36 3.57232 35.6254 2.95856 34.9586C2.3448 34.2918 2 33.3874 2 32.4445V15.5556C2 14.6126 2.3448 13.7082 2.95856 13.0414C3.57232 12.3746 4.40475 12 5.27273 12H12L14.6 4.00004L25.4 4L28 12H34.7273C35.5953 12 36.4277 12.3746 37.0414 13.0414C37.6552 13.7082 38 14.6126 38 15.5556V32.4445Z"
        stroke={colorIcon}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <Path
        d="M20 29C23.866 29 27 25.866 27 22C27 18.134 23.866 15 20 15C16.134 15 13 18.134 13 22C13 25.866 16.134 29 20 29Z"
        stroke={colorIcon}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </Svg>
  );
};

export { Camera };
